module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
var showHeader = 'none';
var headerHeight = 0;

if (u.isTrue(hasTitle)) {
    showHeader = 'inline-block';
    headerHeight = parseInt(titleHeight) + parseInt(borderSize);
}

console.log(borderSize);
console.log(borderStyle);


    ; __append("\r\n\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\"\r\n     class=\"pf-control pf-selectable pf-section-control\"\r\n     draggable=\"false\"\r\n     oncontextmenu=\"return false\"\r\n     style=\"\r\n         border-width: ")
    ; __append(escapeFn( borderSize ))
    ; __append("px;\r\n         border-style: ")
    ; __append(escapeFn( borderStyle ))
    ; __append(";\r\n         border-color: ")
    ; __append(escapeFn( borderColor ))
    ; __append(";\r\n         border-radius: ")
    ; __append(escapeFn( cornerRadius ))
    ; __append("px;\r\n         margin-top: ")
    ; __append(escapeFn( marginTop ))
    ; __append("px;\r\n         margin-bottom: ")
    ; __append(escapeFn( marginBottom ))
    ; __append("px;\r\n         margin-left: 5px;\r\n         margin-right: 5px;\r\n         position: relative;\">\r\n\r\n    <div\r\n        id=\"section_")
    ; __append(escapeFn( id ))
    ; __append("\"\r\n        class=\"pf-control-core\"\r\n        style=\"display: block;\r\n               min-width: ")
    ; __append(escapeFn( minWidth ))
    ; __append(";\r\n               background-color: ")
    ; __append(escapeFn( GroupBackgroundColor ))
    ; __append(";\r\n                ")
    ; __append(escapeFn( pictureStyle ))
    ; __append(";\">\r\n            <div id=\"sectionHeaderContainer_")
    ; __append(escapeFn( id ))
    ; __append("\"\r\n                 class=\"\"\r\n                 style=\"\r\n                     font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(titleFontFamily)))
    ; __append(";\r\n                     font-size: ")
    ; __append(escapeFn(titleFontSize))
    ; __append("px;\r\n                     font-style: ")
    ; __append(escapeFn(titleTextStyle))
    ; __append(";\r\n                     font-weight: ")
    ; __append(escapeFn(titleTextWeight))
    ; __append(";\r\n                     color: ")
    ; __append(escapeFn(titleColor))
    ; __append(";\r\n                     background-color:")
    ; __append(escapeFn(titleBackgroundColor))
    ; __append(";\r\n                     min-width: ")
    ; __append(escapeFn( minWidth ))
    ; __append(";\r\n\r\n                     border-bottom-width: ")
    ; __append(escapeFn( headerBorderSize ))
    ; __append("px;\r\n                     border-bottom-style: ")
    ; __append(escapeFn( headerBorderStyle ))
    ; __append(";\r\n                     border-bottom-color: ")
    ; __append(escapeFn( borderColor ))
    ; __append(";\r\n                        \">\r\n                <div id=\"sectionHeaderHandler_")
    ; __append(escapeFn( id ))
    ; __append("\"\r\n                     style=\"float: left; color: #303030;\">\r\n                    <div>\r\n\r\n                        <i class=\"fa pf-drag draggable\"></i>\r\n                    </div>\r\n                </div>\r\n                <div id=\"sectionHeaderText_")
    ; __append(escapeFn( id ))
    ; __append("\"\r\n                     style=\"text-align:")
    ; __append(escapeFn( titleAlign ))
    ; __append(";\r\n                            display:  ")
    ; __append(escapeFn(showHeader ))
    ; __append(" ;\r\n                            width: calc(85% - 15px);\r\n                            height: ")
    ; __append(escapeFn(headerHeight ))
    ; __append("px;\" >\r\n                    ")
    ; __append(escapeFn( titleText ))
    ; __append("\r\n                </div>\r\n            </div>\r\n            <div id=\"sectionBodyContainer_")
    ; __append(escapeFn( id ))
    ; __append("\"\r\n                 style=\"\r\n                 display: grid;\r\n                 height: auto;\r\n                 min-height: 35px;\r\n                 padding: 2px;\r\n                 min-width: ")
    ; __append(escapeFn( minWidth ))
    ; __append(";\" class=\"mobile-section-content\">\r\n\r\n            </div>\r\n\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}